/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const initScan = /* GraphQL */ `mutation InitScan($accountId: String!, $resources: String) {
  initScan(accountId: $accountId, resources: $resources) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.InitScanMutationVariables,
  APITypes.InitScanMutation
>;
export const doScan = /* GraphQL */ `mutation DoScan($accountId: String!, $resourceId: String!) {
  doScan(accountId: $accountId, resourceId: $resourceId) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DoScanMutationVariables,
  APITypes.DoScanMutation
>;
export const updatePricing = /* GraphQL */ `mutation UpdatePricing($accountId: String!, $resourceId: String!) {
  updatePricing(accountId: $accountId, resourceId: $resourceId) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePricingMutationVariables,
  APITypes.UpdatePricingMutation
>;
export const batchGetEc2Prices = /* GraphQL */ `mutation BatchGetEc2Prices($resources: [Ec2ResourceReq]!) {
  batchGetEc2Prices(resources: $resources) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BatchGetEc2PricesMutationVariables,
  APITypes.BatchGetEc2PricesMutation
>;
export const checkout = /* GraphQL */ `mutation Checkout($accountId: String!, $productId: String!) {
  checkout(accountId: $accountId, productId: $productId) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CheckoutMutationVariables,
  APITypes.CheckoutMutation
>;
export const validatePayment = /* GraphQL */ `mutation ValidatePayment($accountId: String!, $sessionId: String!) {
  validatePayment(accountId: $accountId, sessionId: $sessionId) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ValidatePaymentMutationVariables,
  APITypes.ValidatePaymentMutation
>;
export const freeQuota = /* GraphQL */ `mutation FreeQuota($accountId: String!) {
  freeQuota(accountId: $accountId) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.FreeQuotaMutationVariables,
  APITypes.FreeQuotaMutation
>;
export const createAccountQuota = /* GraphQL */ `mutation CreateAccountQuota(
  $input: CreateAccountQuotaInput!
  $condition: ModelAccountQuotaConditionInput
) {
  createAccountQuota(input: $input, condition: $condition) {
    accountId
    scanQuota
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountQuotaMutationVariables,
  APITypes.CreateAccountQuotaMutation
>;
export const updateAccountQuota = /* GraphQL */ `mutation UpdateAccountQuota(
  $input: UpdateAccountQuotaInput!
  $condition: ModelAccountQuotaConditionInput
) {
  updateAccountQuota(input: $input, condition: $condition) {
    accountId
    scanQuota
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountQuotaMutationVariables,
  APITypes.UpdateAccountQuotaMutation
>;
export const deleteAccountQuota = /* GraphQL */ `mutation DeleteAccountQuota(
  $input: DeleteAccountQuotaInput!
  $condition: ModelAccountQuotaConditionInput
) {
  deleteAccountQuota(input: $input, condition: $condition) {
    accountId
    scanQuota
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountQuotaMutationVariables,
  APITypes.DeleteAccountQuotaMutation
>;
export const createAccountPayments = /* GraphQL */ `mutation CreateAccountPayments(
  $input: CreateAccountPaymentsInput!
  $condition: ModelAccountPaymentsConditionInput
) {
  createAccountPayments(input: $input, condition: $condition) {
    accountId
    orderId
    productId
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountPaymentsMutationVariables,
  APITypes.CreateAccountPaymentsMutation
>;
export const updateAccountPayments = /* GraphQL */ `mutation UpdateAccountPayments(
  $input: UpdateAccountPaymentsInput!
  $condition: ModelAccountPaymentsConditionInput
) {
  updateAccountPayments(input: $input, condition: $condition) {
    accountId
    orderId
    productId
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountPaymentsMutationVariables,
  APITypes.UpdateAccountPaymentsMutation
>;
export const deleteAccountPayments = /* GraphQL */ `mutation DeleteAccountPayments(
  $input: DeleteAccountPaymentsInput!
  $condition: ModelAccountPaymentsConditionInput
) {
  deleteAccountPayments(input: $input, condition: $condition) {
    accountId
    orderId
    productId
    status
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountPaymentsMutationVariables,
  APITypes.DeleteAccountPaymentsMutation
>;
export const createEc2Price = /* GraphQL */ `mutation CreateEc2Price(
  $input: CreateEc2PriceInput!
  $condition: ModelEc2PriceConditionInput
) {
  createEc2Price(input: $input, condition: $condition) {
    instanceType
    region
    price
    location
    instanceFamily
    vCPU
    memory
    storage
    networkPerformance
    operatingSystem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEc2PriceMutationVariables,
  APITypes.CreateEc2PriceMutation
>;
export const updateEc2Price = /* GraphQL */ `mutation UpdateEc2Price(
  $input: UpdateEc2PriceInput!
  $condition: ModelEc2PriceConditionInput
) {
  updateEc2Price(input: $input, condition: $condition) {
    instanceType
    region
    price
    location
    instanceFamily
    vCPU
    memory
    storage
    networkPerformance
    operatingSystem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEc2PriceMutationVariables,
  APITypes.UpdateEc2PriceMutation
>;
export const deleteEc2Price = /* GraphQL */ `mutation DeleteEc2Price(
  $input: DeleteEc2PriceInput!
  $condition: ModelEc2PriceConditionInput
) {
  deleteEc2Price(input: $input, condition: $condition) {
    instanceType
    region
    price
    location
    instanceFamily
    vCPU
    memory
    storage
    networkPerformance
    operatingSystem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEc2PriceMutationVariables,
  APITypes.DeleteEc2PriceMutation
>;
export const createUserInfo = /* GraphQL */ `mutation CreateUserInfo(
  $input: CreateUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  createUserInfo(input: $input, condition: $condition) {
    userId
    accounts {
      items {
        accountId
        monitorRoleArn
        accountName
        refreshRule
        createdAt
        updatedAt
        userInfoAccountsUserId
        owner
        __typename
      }
      nextToken
      __typename
    }
    userName
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserInfoMutationVariables,
  APITypes.CreateUserInfoMutation
>;
export const updateUserInfo = /* GraphQL */ `mutation UpdateUserInfo(
  $input: UpdateUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  updateUserInfo(input: $input, condition: $condition) {
    userId
    accounts {
      items {
        accountId
        monitorRoleArn
        accountName
        refreshRule
        createdAt
        updatedAt
        userInfoAccountsUserId
        owner
        __typename
      }
      nextToken
      __typename
    }
    userName
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserInfoMutationVariables,
  APITypes.UpdateUserInfoMutation
>;
export const deleteUserInfo = /* GraphQL */ `mutation DeleteUserInfo(
  $input: DeleteUserInfoInput!
  $condition: ModelUserInfoConditionInput
) {
  deleteUserInfo(input: $input, condition: $condition) {
    userId
    accounts {
      items {
        accountId
        monitorRoleArn
        accountName
        refreshRule
        createdAt
        updatedAt
        userInfoAccountsUserId
        owner
        __typename
      }
      nextToken
      __typename
    }
    userName
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserInfoMutationVariables,
  APITypes.DeleteUserInfoMutation
>;
export const createAccountInfo = /* GraphQL */ `mutation CreateAccountInfo(
  $input: CreateAccountInfoInput!
  $condition: ModelAccountInfoConditionInput
) {
  createAccountInfo(input: $input, condition: $condition) {
    accountId
    monitorRoleArn
    accountName
    refreshRule
    createdAt
    updatedAt
    userInfoAccountsUserId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountInfoMutationVariables,
  APITypes.CreateAccountInfoMutation
>;
export const updateAccountInfo = /* GraphQL */ `mutation UpdateAccountInfo(
  $input: UpdateAccountInfoInput!
  $condition: ModelAccountInfoConditionInput
) {
  updateAccountInfo(input: $input, condition: $condition) {
    accountId
    monitorRoleArn
    accountName
    refreshRule
    createdAt
    updatedAt
    userInfoAccountsUserId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountInfoMutationVariables,
  APITypes.UpdateAccountInfoMutation
>;
export const deleteAccountInfo = /* GraphQL */ `mutation DeleteAccountInfo(
  $input: DeleteAccountInfoInput!
  $condition: ModelAccountInfoConditionInput
) {
  deleteAccountInfo(input: $input, condition: $condition) {
    accountId
    monitorRoleArn
    accountName
    refreshRule
    createdAt
    updatedAt
    userInfoAccountsUserId
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountInfoMutationVariables,
  APITypes.DeleteAccountInfoMutation
>;
export const createAccountToResource = /* GraphQL */ `mutation CreateAccountToResource(
  $input: CreateAccountToResourceInput!
  $condition: ModelAccountToResourceConditionInput
) {
  createAccountToResource(input: $input, condition: $condition) {
    accountId
    resourceId
    resourceRegion
    resourceStatus
    resourceType
    resourceCreatedAt
    resourcePriceType
    tags
    index
    summary {
      resourceType
      status
      scannedCount
      idleCount
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountToResourceMutationVariables,
  APITypes.CreateAccountToResourceMutation
>;
export const updateAccountToResource = /* GraphQL */ `mutation UpdateAccountToResource(
  $input: UpdateAccountToResourceInput!
  $condition: ModelAccountToResourceConditionInput
) {
  updateAccountToResource(input: $input, condition: $condition) {
    accountId
    resourceId
    resourceRegion
    resourceStatus
    resourceType
    resourceCreatedAt
    resourcePriceType
    tags
    index
    summary {
      resourceType
      status
      scannedCount
      idleCount
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountToResourceMutationVariables,
  APITypes.UpdateAccountToResourceMutation
>;
export const deleteAccountToResource = /* GraphQL */ `mutation DeleteAccountToResource(
  $input: DeleteAccountToResourceInput!
  $condition: ModelAccountToResourceConditionInput
) {
  deleteAccountToResource(input: $input, condition: $condition) {
    accountId
    resourceId
    resourceRegion
    resourceStatus
    resourceType
    resourceCreatedAt
    resourcePriceType
    tags
    index
    summary {
      resourceType
      status
      scannedCount
      idleCount
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountToResourceMutationVariables,
  APITypes.DeleteAccountToResourceMutation
>;
